import React from 'react'
import Contactpage from '../component/contact/ContactSection'
import Hero from '../component/contact/Hero'

const Contact = () => {
  return (
    <div>
      {/* <Hero /> */}
      <Contactpage />
    </div>
  )
}

export default Contact


